<div *ngIf="initialized" class="container">
    <div class="inventory-top">
        <div class="storeInfo">
            <p>Store Number: {{headerInfo.storeNum}}</p>
            <p>Order Number: {{headerInfo.orderNumber}}</p>
            <p>On Screen Balancing: {{headerInfo.receiptDate}}</p>

        </div>
        <div class="receivingForm">
            <div class="inputGroups">
                <div class="inventory-tbGroup">
                    <div class="inventoryInput">
                        <label for="inv-receiptTotalsearchBox">Receipt Total</label>
                        <kendo-numerictextbox (blur)="onInputChange()"
                                              [(ngModel)]="inventoryService.inventoryDetails.header.receiptTotal"
                                              class="searchItem headerInputs"
                                              format="c"
                                              spinners="false"></kendo-numerictextbox>

                    </div>

                    <div class="inventoryInput">
                        <label for="inv-salesTaxtext"> Sales Tax</label>
                        <kendo-numerictextbox (blur)="onInputChange()"
                                              [(ngModel)]="inventoryService.inventoryDetails.header.salesTax"
                                              class="searchItem headerInputs"
                                              format="c"
                                              spinners="false"></kendo-numerictextbox>
                    </div>
                    <div class="inventoryInput">
                        <label for="discounttext">Discount</label>
                        <kendo-numerictextbox (blur)="onInputChange()"
                                              [(ngModel)]="inventoryService.inventoryDetails.header.discount"
                                              class="searchItem headerInputs"
                                              format="c"
                                              spinners="false"></kendo-numerictextbox>
                    </div>
                    <div class="inventoryInput">
                        <label for="computedItemText">Surcharge</label>
                        <kendo-numerictextbox (blur)="onInputChange()"
                                              [(ngModel)]="inventoryService.inventoryDetails.header.surcharge"
                                              class="searchItem headerInputs"
                                              format="c"
                                              spinners="false"></kendo-numerictextbox>
                    </div>
                </div>
                <div class="inventory-tbGroup">
                    <div class="inventoryInput">
                        <label for="inv-entRec">Entered Receipt Total</label><!---->
                        <kendo-numerictextbox (blur)="onInputChange()"
                                              [(ngModel)]="inventoryService.inventoryDetails.header.receiptTotal"
                                              class="searchItem headerInputs disabledHeader"
                                              disabled="disabled" format="c"
                                              spinners="false"></kendo-numerictextbox>
                    </div>
                    <div class="inventoryInput">
                        <label for="inv-entAdjTotaltext">Entered Adjustments</label>
                        <kendo-numerictextbox (blur)="onInputChange()" [(ngModel)]="inventoryService.adjustments"
                                              class="searchItem headerInputs disabledHeader"
                                              disabled="disabled" format="c"
                                              spinners="false"></kendo-numerictextbox>

                    </div>
                    <div class="inventoryInput">
                        <label for="surcharges">Computed Item Total</label>
                        <kendo-numerictextbox (blur)="onInputChange()" [(ngModel)]="inventoryService.compTotal"
                                              class="searchItem headerInputs disabledHeader"
                                              disabled="disabled" format="c"
                                              spinners="false"></kendo-numerictextbox>
                    </div>
                    <div class="inventoryInput">
                        <label for="inv-computedTotalText">Computed Total</label>
                        <kendo-numerictextbox (blur)="onInputChange()" [(ngModel)]="inventoryService.compDiff"
                                              class="searchItem headerInputs disabledHeader"
                                              disabled="disabled" format="c"
                                              spinners="false"></kendo-numerictextbox>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <div class="inventory-grid">
        <kendo-grid #inventoryGrid (cancel)="this.kendoHelper.cancelHandler()"
                    (cellClick)="this.cellClickHandler($event)"
                    (dataStateChange)="onInventoryGriddataStateChange($event)"
                    (pageChange)="onInventoryGridpageChange($event)"
                    (selectionChange)="this.onSelectionChangeHandler($event)"
                    [data]="gridData"
                    [filter]="state.filter"
                    [filterable]="true"
                    [kendoGridSelectBy]="removeCallBack"
                    [navigable]="true"
                    [pageSize]="30"
                    [reorderable]="true"
                    [resizable]="true"
                    [rowHeight]="36"
                    [selectable]="{ checkboxOnly: false, mode: 'single'}"
                    [selectedKeys]="inventoryService.inventoryItemSelected"
                    [skip]="state.skip"
                    [sort]="state.sort"
                    [sortable]="true"
                    id="inventoryGrid"
                    scrollable="virtual"
                    style="height: 400px">
            <kendo-grid-column *ngFor="let col of columns"
                               [editable]="col.editable"
                               [editor]="col.editor"
                               [field]="col.field"
                               [filterable]="col.filterable"
                               [format]="col.format"
                               [media]="col.media"
                               [title]="col.title"
                               [width]="col.width"
                               [style]="col.style"
                               filterable="true">
            </kendo-grid-column>

        </kendo-grid>
    </div>
    <div class="buttonBar">

        <app-mcl-button (buttonPressed)="openAllItemsDialog()" [disabled]="" id="but-add"
                       text="Add Items" primary="true"></app-mcl-button>
        <app-mcl-button (buttonPressed)="deleteItem()"
                       [disabled]="inventoryService.inventoryItemSelected.length < 1" id="but-delete"
                    text="Delete Item" primary="true"></app-mcl-button>
        <app-mcl-button (buttonPressed)="openPartialBox(dialog)"
                       [disabled]="inventoryService.inventoryItemSelected.length < 1" id="but-count"
                       text="Partial" primary="true"></app-mcl-button>
        <app-mcl-button  (buttonPressed)="onCancel()" id="but-cancel"
                       text="Cancel" primary="true"></app-mcl-button>
        <app-mcl-button (buttonPressed)="onSave()"
                       id="but-save" text="Done" primary="true"></app-mcl-button>
    </div>
</div>
<div kendoDialogContainer></div>
<app-partialdialog #dialog></app-partialdialog>

